module.exports = __webpack_public_path__ + "img/KSC01519.cd3df779.jpg";